import styled from "styled-components";
import ReservationButton from "./buttons/StyledReservation";
import { Link } from "react-router-dom";

import ReactPlayer from "react-player";
import { useEffect, useState } from "react";
import { device } from "../styled";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  @media ${device.desktop} {
    margin-top: -80px;
  }
  a {
    text-decoration: none;
  }
`;

const VideoContainer = styled.div`
  background-color: #000;
  height: 100%;
  video {
    right: 0;
    bottom: 0;
    object-fit: cover;
    background-color: #000;
  }
`;

const LinkContainer = styled.div`
  button {
    margin-left: auto;
    margin-right: auto;
    left: 0;
    right: 0;
    text-align: center;
    position: absolute;
    bottom: 15%;

    @media ${device.tablet} {
      bottom: 13%;
    }
  }
`;

const VideoPlaceHolder = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100svh;
  background-color: #000;
`;

const SocialIconContainer = styled.div`
  position: absolute;
  bottom: 5%;
  display: flex;
  width: 100%;
  justify-content: center;
  gap: 10px;
`;

const SocialIcon = styled.img`
  width: 50px;

  &:hover {
    background-color: #008080;
    border-radius: 10px;
  }
`;

const Banner = () => {
  const [isVideoReady, setIsVideoReady] = useState(false);
  const [isPlaceholder, setIsPlaceholder] = useState(true);
  useEffect(() => {
    setIsPlaceholder(false);
  }, [isVideoReady]);

  return (
    <Container>
      <VideoPlaceHolder>
        {!isPlaceholder && (
          <VideoContainer>
            <ReactPlayer
              url="/artis_promo_16_9.mp4"
              playing
              muted
              playsinline
              loop
              width={"100vw"}
              height={"100svh"}
              onReady={() => setIsVideoReady(true)}
            />
          </VideoContainer>
        )}
      </VideoPlaceHolder>

      <LinkContainer>
        <Link to={"artist-barbershops"}>
          <ReservationButton />
        </Link>
      </LinkContainer>
      <SocialIconContainer>
        <Link to={"https://www.facebook.com/artistmalehairdressing"}>
          <SocialIcon src={"/fb.svg"} />
        </Link>
        <Link
          to={
            "https://www.tiktok.com/@kecso__?is_from_webapp=1&sender_device=pc"
          }
        >
          <SocialIcon src={"/tiktok.svg"} />
        </Link>
        <Link>
          <SocialIcon src={"/insta.svg"} />
        </Link>
      </SocialIconContainer>
    </Container>
  );
};

export default Banner;
